import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "excel-fontColorA",
  "use": "excel-fontColorA-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol viewBox=\"0 0 12 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"excel-fontColorA\">\n<path d=\"M1.21777 10.2266L2.81269 7.08257M2.81269 7.08257L3.61013 5.51053L6.00249 0.794434L8.39485 5.51053L9.19229 7.08257M2.81269 7.08257H9.19229M10.7872 10.2266L9.19229 7.08257\" stroke=\"#464646\" stroke-width=\"1.12489\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol